import { TextRegular } from "@hm/fundamental"
import { FormattedCountry } from "@shared/models"

interface FlagIconProps {
	code: string
	className?: string
	style?: React.CSSProperties
}

export const FlagIcon: React.FC<FlagIconProps> = ({
	code,
	className = "",
	style,
}) => {
	const flagClasses = `fi fi-${code.toLowerCase()} fi-xx ${className}`
	return <span className={flagClasses} style={style}></span>
}

interface CountryPillProps {
	country: FormattedCountry
	countryCode: string
}

export const CountryPill: React.FC<CountryPillProps> = ({
	country,
	countryCode,
}) => (
	<div className="flex items-center w-full">
		<FlagIcon code={countryCode}></FlagIcon>
		<TextRegular className="ml-2">{country.name}</TextRegular>
	</div>
)
